function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "var(--primary-color, #000)",
  strokeLinecap: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M31 2s-1.597 2.967-2.773 6.717C26.824 6.845 26 5.559 26 5.559s-1.509 5.372-.625 9.578a35.2 35.2 0 00-1.445-.825s.358 5.506 2.326 8.676c.87 1.401 1.837 2.51 2.744 3.256V52c0 1.108.892 2 2 2s2-.892 2-2V26v-.008c1.41-1.522 2.217-3.793 2.783-5.623 1.29-4.295.137-10.549.137-10.549s-.613.578-1.441 1.528C33.399 6.453 31 2 31 2z",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M27.6 7.92l2.4 3.55M25.5 15.259L28 17.39M34.7 10.997L32 15.022"
}));

var SvgAsparagus = function SvgAsparagus(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAsparagus, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Asparagus.619fe95a.svg";
export { ForwardRef as ReactComponent };